/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import { ReactNode, useEffect, memo } from 'react';
import UtilsService from '../../Services/UtilsService';
//  Layout.tsx should be imported first in every file that uses it (css ordering issues)
import '../../styles/_global.scss';
import './layout.scss';

import Footer from '../Footer/Footer';
import FooterSlim from '../../components/FooterSlim/FooterSlim';
import NavBar from '../NavBar/NavBar';
import OGTags from '../../Services/OGTagsService';
import PageLoadService from '../../Services/PageLoadService';
import NavBarTools from '../NavBar/NavBarTools';
import type { TOGTags } from '../../types/util-types';
import ABTestToolServiceV2 from '../../Services/ABTestToolService.v2';
import CloudflareBannerService from '../../Services/CloudflareBannerService';
import { ABTestFallbackVariants } from '../../ab-tests/ABTestFallbackVariants';
import MobileStickyCTA from '../../components/MobileStickyCTA/MobileStickyCTA';
import { TryForFreeCtaContext } from '../../context/TryForFreeContext';

interface Props {
    ogTags: TOGTags;
    navBarTools?: boolean;
    lang?: 'en' | 'es'; // TODO: add more languages then required
    children?: ReactNode;
    slimNav?: boolean;
    noNav?: boolean;
    noFooter?: boolean;
    slimFooter?: boolean;
    noPromo?: boolean;
    customClass?: string;
    noCta?: boolean;
    mobileStickyCTA?: boolean;
    isCtaTest?: boolean;
    customCtaText?: string | ReactNode;
    mobileStickyCTAOffset?: number;
}

function Layout({
    children,
    ogTags,
    navBarTools = false,
    lang,
    slimNav = false,
    noFooter = false,
    slimFooter = false,
    noPromo = false,
    noNav = false,
    customClass,
    noCta = false,
    mobileStickyCTA = false,
    isCtaTest = false,
    customCtaText = '',
    mobileStickyCTAOffset = 100
}: Props): React.ReactElement {
    const handleAnalyticsAndPageLoad = () => {
        ABTestToolServiceV2?.fireAbTestAnalytics(window.location.pathname);
        PageLoadService.handlePageAnalytics();
    };

    useEffect(() => {
        UtilsService.storeInitialUtms();
        UtilsService.storeCoupon(undefined);
        handleAnalyticsAndPageLoad();
        CloudflareBannerService.hideAndTrackBanner();
    }, []);

    return (
        <TryForFreeCtaContext.Provider value={{ isCtaTest, customCtaText }}>
            <div className={`${customClass ?? ''}`}>
                <ABTestFallbackVariants />

                <OGTags {...ogTags} lang={lang} />
                {!noNav && (
                    <>
                        {navBarTools ? (
                            <NavBarTools />
                        ) : (
                            <NavBar slimNav={slimNav} noCta={noCta} />
                        )}
                    </>
                )}
                {children}
                {!noFooter && !slimFooter && <Footer />}
                {slimFooter && <FooterSlim />}
                {mobileStickyCTA && (
                    <MobileStickyCTA pixelOffset={mobileStickyCTAOffset} />
                )}
            </div>
        </TryForFreeCtaContext.Provider>
    );
}

export default memo(Layout);
